export default {"src":"/_next/static/media/ancap-logo.b0dc0f3c.svg","height":55,"width":190,"blurWidth":0,"blurHeight":0};